






















import { Component, Prop, Vue } from "vue-property-decorator";

import BaseButton from "@/components/BaseButton/BaseButton.vue";

import StudentsTable from "@/components/StudentsTable/StudentsTable.vue";
import { IStudent } from "@/models/interfaces/students";
import amplitude from "amplitude-js";
import { eventCodeByName, EventsNames } from "@/analytics";

@Component({
  components: {
    BaseButton,
    StudentsTable
  }
})
export default class ClassAddStep2 extends Vue {
  @Prop({ required: true, type: Array })
  private students!: IStudent[];

  @Prop({ type: Array })
  private initialData!: string[];

  private selectedStudentsIds: string[] = [];

  private next() {
    amplitude
      .getInstance()
      .logEvent(
        `${eventCodeByName(EventsNames.UserClicksNextOnStep2Class)} ${
          EventsNames.UserClicksNextOnStep2Class
        }`
      );

    this.$emit("on-next", this.selectedStudentsIds);
  }

  private setStudents(data: string[]) {
    this.selectedStudentsIds = data;
  }

  public mounted() {
    this.selectedStudentsIds = this.initialData || [];
  }
}
